import { useEffect, useState } from 'react';
import { Video } from 'lucide-react';

const isLive = (t) => {
  if (!t.date_debut || !t.heure_debut) return false;
  const start = new Date(`${t.date_debut.slice(0, 10)}T${t.heure_debut}:00`);
  const end = t.heure_fin ? new Date(`${(t.date_fin || t.date_debut).slice(0, 10)}T${t.heure_fin}:00`) : new Date(start.getTime() + 3600000);
  const now = Date.now();
  return now >= start.getTime() - 10 * 60000 && now <= end.getTime();
};

// Badge « Google » + bouton « Rejoindre » d'un call importé ; mis en avant 10 min avant le début.
export const JoinCallButton = ({ task, compact = false }) => {
  const [, tick] = useState(0);
  useEffect(() => { const iv = setInterval(() => tick((x) => x + 1), 30000); return () => clearInterval(iv); }, []);
  if (task.source !== 'gcal' && task.source !== 'gtasks') return null;
  const live = task.meet_link && isLive(task);
  const stop = (e) => e.stopPropagation();
  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 5, flexWrap: 'wrap' }}>
      <span data-testid={`google-badge-${task.id}`} style={{ padding: '1px 6px', borderRadius: 999, background: 'rgba(66,133,244,0.16)', border: '1px solid rgba(66,133,244,0.45)', color: '#8AB4F8', fontFamily: 'Sora', fontWeight: 800, fontSize: 9, letterSpacing: '0.02em' }}>GOOGLE</span>
      {task.meet_link && (
        <span
          role="button"
          tabIndex={0}
          data-testid={`join-call-${task.id}`}
          onPointerDown={stop}
          onMouseDown={stop}
          onClick={(e) => { stop(e); window.open(task.meet_link, '_blank', 'noopener'); }}
          style={{
            display: 'inline-flex', alignItems: 'center', gap: 4, padding: compact ? '2px 7px' : '3px 9px', borderRadius: 999, cursor: 'pointer',
            background: live ? '#34D399' : 'rgba(52,211,153,0.14)', border: '1px solid rgba(52,211,153,0.6)',
            color: live ? '#06281C' : '#34D399', fontFamily: 'Sora', fontWeight: 800, fontSize: compact ? 9.5 : 10.5,
            boxShadow: live ? '0 0 0 3px rgba(52,211,153,0.25)' : 'none', transition: 'background-color 0.15s, box-shadow 0.15s',
          }}
        ><Video size={compact ? 10 : 11} />Rejoindre</span>
      )}
    </span>
  );
};
